/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.4.0-nightly.2026.7.8",
    versionName: "0.4.0-nightly.2026.7.8",
    versionChannel: "nightly",
    buildDate: "2026-07-08T00:48:38.830Z",
    commitHash: "4d83404b788193a7b02c22116a712dce7a093077",
};
